<!--
 * @Desc: 网站首页
   标签类名，使用-进行分割命名，如page-home、item-form
   标签id，使用小驼峰规则命名，如homeId、itemId
   变量名，使用小驼峰规则命名，如publicPath、wxCode
 * @Author: 赵佳明
 * @Date: 2023-01-30 09:11:04
 * @LastEditors: 赵佳明
 * @LastEditTime: 2023-02-03 10:10:24
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved.
-->
<template>
  <div class="page-index">
    <!-- 内容区 -->
    <!-- banner -->
    <SRF>
      <div class="banner-box">
        <!-- 开发 + 设计 创新未来价值 -->
        <div class="title" id="titleRef"></div>
        <!-- 帮 助 企 业 快 速 实 现 互 联 网 转 型 -->
        <div class="mark" id="markRef"></div>
        <div class="mouse-icon">
          <img src="@/assets/home/phone.png" alt="" />
        </div>
      </div>
    </SRF>
    <!-- 业务流程 -->
    <SRF position="left">
      <Process />
    </SRF>

    <!-- 核心理念 -->
    <SRF position="left">
      <Core />
    </SRF>

    <!-- 横幅 -->
    <SRF>
      <Banner />
    </SRF>

    <!-- 合作伙伴 -->
    <SRF>
      <Partner />
    </SRF>

    <!-- Footer -->
    <Footer />
  </div>
</template>

<script>
import utils from "@/api/Utils";
import Process from "./components/Process";
import Core from "./components/Core";
import Banner from "./components/Banner";
import Partner from "./components/Partner";
import Footer from "@/components/Footer";
export default {
  name: "home",
  data() {
    return {};
  },
  components: { Process, Core, Banner, Partner, Footer },
  created() {
    setTimeout(() => {
      this.$nextTick(() => {
        new this.Typed("#titleRef", {
          strings: ["开发 + 设计 创新未来价值"],
          typeSpeed: 100,
        });

        new this.Typed("#markRef", {
          strings: ["为企业打造高效的数字营销路径，实现可持续增长"],
          typeSpeed: 60,
        });
      });
    }, 1000);
  },
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import url("./index.scss");
</style>
